var _rect, _polyline, _polyline2, _polyline3, _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDonutThumb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1000,
    height: 600,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    baseProfile: "full",
    viewBox: "0 0 1000 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1000,
    height: 600,
    x: 0,
    y: 0,
    id: 0,
    fill: "#FFFFFF"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "669.7 222 682.7 214.5 697.7 214.5",
    fill: "none",
    stroke: "#009bd7"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    points: "500 516 500 531 485 531",
    fill: "none",
    stroke: "#f0a82d"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    points: "330.3 222 317.3 214.5 302.3 214.5",
    fill: "none",
    stroke: "#e95000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M500 124A196 196 0 0 1 669.741 418L560.6218 355A70 70 0 0 0 500 250Z",
    fill: "rgb(0,155,215)",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M669.741 418A196 196 0 0 1 330.259 418L439.3782 355A70 70 0 0 0 560.6218 355Z",
    fill: "#f0a82d",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M330.259 418A196 196 0 0 1 500 124L500 250A70 70 0 0 0 439.3782 355Z",
    fill: "rgb(233,80,0)",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "start",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(702.7314 214.5)",
    fill: "#333",
    stroke: "rgb(255,255,255)",
    strokeWidth: 2,
    paintOrder: "stroke",
    strokeMiterlimit: 2
  }, "Premiere_Year"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "end",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(480 531)",
    fill: "#333",
    stroke: "rgb(255,255,255)",
    strokeWidth: 2,
    paintOrder: "stroke",
    strokeMiterlimit: 2
  }, "Seasons"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "end",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(297.2686 214.5)",
    fill: "#333",
    stroke: "rgb(255,255,255)",
    strokeWidth: 2,
    paintOrder: "stroke",
    strokeMiterlimit: 2
  }, "Episodes"), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M-5 -5l298.5667 0l0 26l-298.5667 0Z",
    transform: "translate(355.7167 575)",
    fill: "rgb(0,0,0)",
    fillOpacity: 0,
    stroke: "#ccc",
    strokeWidth: 0
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 0L21.5 0A3.5 3.5 0 0 1 25 3.5L25 10.5A3.5 3.5 0 0 1 21.5 14L3.5 14A3.5 3.5 0 0 1 0 10.5L0 3.5A3.5 3.5 0 0 1 3.5 0",
    transform: "translate(356.7167 576)",
    fill: "#009bd7",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinecap: "butt",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "start",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    x: 30,
    y: 7,
    transform: "translate(356.7167 576)",
    fill: "#333"
  }, "Premiere_Year"), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 0L21.5 0A3.5 3.5 0 0 1 25 3.5L25 10.5A3.5 3.5 0 0 1 21.5 14L3.5 14A3.5 3.5 0 0 1 0 10.5L0 3.5A3.5 3.5 0 0 1 3.5 0",
    transform: "translate(477.2833 576)",
    fill: "#f0a82d",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinecap: "butt",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "start",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    x: 30,
    y: 7,
    transform: "translate(477.2833 576)",
    fill: "#333"
  }, "Seasons"), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 0L21.5 0A3.5 3.5 0 0 1 25 3.5L25 10.5A3.5 3.5 0 0 1 21.5 14L3.5 14A3.5 3.5 0 0 1 0 10.5L0 3.5A3.5 3.5 0 0 1 3.5 0",
    transform: "translate(564.95 576)",
    fill: "#e95000",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinecap: "butt",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "start",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    x: 30,
    y: 7,
    transform: "translate(564.95 576)",
    fill: "#333"
  }, "Episodes"));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDonutThumb);
export default __webpack_public_path__ + "static/media/donut_thumb.97ec231ad9362e9bfd35550bb9d0b701.svg";
export { ForwardRef as ReactComponent };